module.exports = __webpack_public_path__ + "static/img/pattie-owen.1a38631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pattie-owen.jpg
// module id = lSA5
// module chunks = 0